import React from "react";
import { observer } from "mobx-react-lite";
import { Card, CardContent, CardHeader } from "@mui/material";

import { Address, TelFax, Email } from "../../../../../components/svg/svgImageList";
import { translationService } from "../../../../../services/translation/TranslationService";
import Svg from "../../../../../components/svg/Svg";
import "./EnterpriseSubscriptionCard.scss";
import "../../composition.scss";

export const EnterpriseSubscriptionCard = observer(() => {
  return (
    <Card className="subscription-plan-card" variant="outlined">
      <CardHeader
        className="header"
        title={translationService.translate("SubscriptionPlans.card.Enterprise")}
      />
      <CardContent className="enterprise-content">
        <div className="plan-description">
          {translationService.translate("SubscriptionPlans.card.Enterprise.description")}
        </div>
        <StaticInfo svg={Address} descriptionKey="general.contact.address" />
        <StaticInfo svg={Email} descriptionKey="general.contact.email" />
        <StaticInfo svg={TelFax} descriptionKey="general.contact.telFax" />
      </CardContent>
    </Card>
  );
});

interface StaticInfoProps {
  svg: React.FunctionComponent;
  descriptionKey: string;
}

const StaticInfo = (props: StaticInfoProps) => {
  const { svg, descriptionKey } = props;
  return (
    <div className="static-info-container">
      <Svg svg={svg} width={50} height={50} />
      <div className="text">{translationService.translate(descriptionKey)}</div>
    </div>
  );
};
